import type { HeaderBackButtonProps } from "@react-navigation/elements"
import { HeaderBackButton as Base } from "@react-navigation/elements"

export default function HeaderBackButton(props: HeaderBackButtonProps) {
  return <Base {...props} />
}
